import { switchClasses as muiSwitchClasses, getSwitchUtilityClass } from '@mui/material';
import {
  Gray, Secondary, Red, Green, Disabled, White, Focused,
} from '../color';

export const switchClasses = {
  ...muiSwitchClasses,
  hoverHalo: getSwitchUtilityClass('hoverHalo'),
  focusVisible: getSwitchUtilityClass('focusVisible'),
  extraSmall: getSwitchUtilityClass('extraSmall'),
};

export const switchSizes: Record<'medium' | 'small' | 'extraSmall', number> = {
  medium: 24,
  small: 16,
  extraSmall: 10,
};

export const Palette = {
  thumb: {
    background: White,
    hover: {
      halo: Secondary.surface.hover,
    },
  },
  border: {
    base: Secondary.container.text,
    disabled: Disabled.default.text,
  },
  track: {
    base: {
      unchecked: Gray[10],
      checked: Gray[100],
    },
    colorful: {
      checked: Green[70],
      unchecked: Red[80],
    },
    disabled: Disabled.default.main,
  },
  icon: {
    base: Gray[100],
    disabled: Disabled.default.text,
  },
  focus: Focused.main,
};

export const HOVER_PADDING = 4;
